import React from 'react';
import Section from '../ui/Section';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const TrustSection = () => {
  const trustPoints = [
    { 
      title: "Founded by a social impact leader", 
      desc: "Lived experience in the sectors we serve, ensuring every decision respects organizational reality.",
      icon: FiIcons.FiUserCheck 
    },
    { 
      title: "Built for charities and arts", 
      desc: "Frameworks designed specifically for the unique constraints and values of mission-led teams.",
      icon: FiIcons.FiHome 
    },
    { 
      title: "Practical leadership advice", 
      desc: "We skip the technical jargon and focus on how AI works in your actual day-to-day operations.",
      icon: FiIcons.FiTool 
    },
    { 
      title: "Human-led approach", 
      desc: "Our methodology ensures AI never compromises human connection or relational trust.",
      icon: FiIcons.FiUsers 
    },
    { 
      title: "SAFE AI Framework", 
      desc: "The industry standard for responsible AI leadership in the social impact sector.",
      icon: FiIcons.FiShield 
    },
    { 
      title: "Leadership focused", 
      desc: "We help senior teams build governance and confidence, not just another software stack.",
      icon: FiIcons.FiAward 
    }
  ];

  return (
    <Section bg="white" className="py-24">
      <div className="max-w-4xl mx-auto text-center mb-16 px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6">Why leaders work with AI CoLab Studio</h2>
        <p className="text-lg text-gray-600">
          We bridge the gap between emerging technology and mission-driven leadership.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {trustPoints.map((point, i) => (
          <motion.div 
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            viewport={{ once: true }}
            className="p-8 bg-brand-cream rounded-3xl border border-gray-100 hover:shadow-md transition-shadow"
          >
            <div className="w-12 h-12 bg-brand-teal/10 rounded-xl flex items-center justify-center text-brand-teal mb-6">
              <SafeIcon icon={point.icon} className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-brand-navy mb-3">{point.title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{point.desc}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default TrustSection;